<template>
  <section v-if="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>Información básica</h4>
      <p>Datos principales de la persona de contacto.</p>
    </header>

    <div class="app-modal__grid two-columns">
      <label class="app-modal-field">
        <span>Nombre *</span>
        <input
          v-model.trim="form.first_name"
          type="text"
          class="form-control"
          placeholder="Nombre"
          autocomplete="off"
          @blur="v$.form.first_name.$touch()"
          :class="{ 'is-invalid': v$.form.first_name.$error }"
        />
        <div class="invalid-feedback d-block" v-if="v$.form.first_name.$error">
          <span v-if="v$.form.first_name.$errors.length">
            {{ v$.form.first_name.$errors[0].$message }}
          </span>
        </div>
      </label>

      <label class="app-modal-field">
        <span>Apellidos</span>
        <input v-model.trim="form.last_name" type="text" class="form-control" placeholder="Apellidos" autocomplete="off" />
      </label>

      <label class="app-modal-field">
        <span>Puesto</span>
        <input v-model.trim="form.job_title" type="text" class="form-control" placeholder="Puesto" autocomplete="off" />
      </label>

      <div class="app-modal-field">
        <span>Cumpleaños</span>
        <VueDatePicker
          v-model="form.birthdate"
          class="app-modal-datepicker"
          menu-class-name="app-modal-datepicker-menu"
          placeholder="Selecciona fecha"
          :enable-time-picker="false"
          auto-apply
          locale="es-MX"
          format="dd/MM/yyyy"
          hide-input-icon
          :show-now-button="true"
          now-button-label="Hoy"
        />
      </div>
    </div>
  </section>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: 'PersonSectionBasic',
  components: { VueDatePicker },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    v$: {
      type: Object,
      required: true,
    },
  },
};
</script>
